import OnSale from "./OnSale";

export default OnSale;